function a(t) {
  if (!Array.isArray(t))
    return [t, t, t];
  if (t.length === 2)
    return [t[0], t[1], t[1]];
  if (t.length === 3)
    return t;
  throw new Error("Invalid props argument");
}
export {
  a as normaliseResponsiveProp
};
